import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup, FormArray } from "@angular/forms";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { customersData } from "./data";

import { Customers } from "./customers.model";
import { DashboardService } from "../../../services/dashboard.service";
import { AlertService } from "ngx-alerts";
import {
  LOCAL_STORAGE,
  SESSION_STORAGE,
  StorageService,
} from "ngx-webstorage-service";
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from "rxjs/operators";
import { PageEvent } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { DeviceStatusDialogComponent } from "../../fleet/device-status-dialog/device-status-dialog.component";

@Component({
  selector: "app-customers",
  templateUrl: "./customers.component.html",
  styleUrls: ["./customers.component.scss"],
})
export class CustomersComponent implements OnInit {
  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  customersData: Customers[];
  validationform: FormGroup;

  customerAddForm: FormGroup;
  customers: any[] = [];
  customerSearch: any = {
    page: 0,
    size: 20,
    search: "",
    channelId: "",
    version: "v2",
  };

  loggedInUser: any;

  totalRecords = 0;
  pageEvent: PageEvent;
  userType = "";
  gameLevelConfigs = [];
  gameLevelsForm: FormGroup;
  constructor(
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    public dashboardService: DashboardService,
    private alertService: AlertService,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private spinner: NgxSpinnerService,
    private matDialog: MatDialog
  ) {
    this.loggedInUser = storage.get("gs-loggedInUser");
    this.userType = this.storage.get("gs-loggedInUserType").toLowerCase();
    this.customerSearch.channelId = this.loggedInUser.channelId;
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Gypsee" },
      {
        label: this.userType == "fleet" ? "Drivers" : "Customers",
        active: true,
      },
    ];

    this.getCustomers();
    this.getGameLevelConfigs();

    this.buildForm();

    this._fetchData();
  }

  private _fetchData() {
    this.customersData = [];
  }

  /**
   * Returns form
   */
  get form() {
    return this.customerAddForm.controls;
  }

  /**
   * Modal Open
   * @param content modal content
   */
  openModal(content: any) {
    this.modalService.open(content, { centered: true });
  }

  /**
   * save the contacts data
   */
  saveData() {
    const name = this.validationform.get("name").value;
    const phone = this.validationform.get("phone").value;
    const balance = this.validationform.get("balance").value;
    const email = this.validationform.get("email").value;
    const date = this.validationform.get("date").value;
    if (this.validationform.valid) {
      this.customersData.push({
        name,
        phone,
        balance,
        email,
        date,
      });
      this.validationform = this.formBuilder.group({
        name: "",
        phone: "",
        balance: "",
        email: "",
        date: "",
      });
      this.modalService.dismissAll();
    }
    this.submitted = true;
  }

  private getGameLevelConfigs = () => {
    console.log("Fetching gamelevel configs");
    this.dashboardService
      .getGameLevelConfigs(this.loggedInUser.channelId)
      .subscribe(
        (res: any) => {
          this.gameLevelConfigs = res.gameLevelConfigs;
          this.gameLevelConfigs.forEach((element) => {
            this.addGameLevelConfig(element);
          });
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  };

  private addGameLevelConfig(element) {
    const conf = this.formBuilder.group({
      levelId: [element.gameLevel.id],
      levelName: [element.gameLevel.levelName],
      id: element.id,
      commissionPercent: [element.commissionPercent],
      safeKmsRequiredForUpgrade: [element.safeKmsRequiredForUpgrade],
      nextLevelUpdateSafeKmsPercent: [element.nextLevelUpdateSafeKmsPercent],
      noOfDays: [element.noOfDays],
    });
    (this.gameLevelsForm.get("gameLevels") as FormArray).push(conf);
  }

  private getCustomers() {
    this.spinner.show();
    this.dashboardService
      .getCustomers(this.customerSearch)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.totalRecords = res.totalRecords;
          this.customers = res.customersV2;
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  private buildForm() {
    this.customerAddForm = this.formBuilder.group({
      mobileNumber: [
        "",
        // Validators.compose([
        //   Validators.minLength(10),
        //   Validators.maxLength(10),
        //   Validators.required,
        //   Validators.pattern(/^[0-9]{10,12}$/),
        // ]),
      ],
      channelId: [this.loggedInUser.channelId],
    });

    this.gameLevelsForm = this.formBuilder.group({
      gameLevels: this.formBuilder.array([]),
    });
  }

  addCustomer() {
    this.submitted = true;
    if (this.customerAddForm.valid) {
      this.spinner.show();
      this.dashboardService
        .addCustomer(this.customerAddForm.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(
          (res: any) => {
            this.alertService.success(res.message);
            this.modalService.dismissAll();
            this.getCustomers();
          },
          (error1) => {
            console.error(error1);
            this.alertService.danger(
              error1 && error1.message ? error1.message : error1
            );
          }
        );
    }
  }

  onCustomerSearch(value: any) {
    this.customerSearch.search = value;
    this.getCustomers();
  }

  onResendCodeClick(item: any) {
    this.customerAddForm.get("mobileNumber").setValue(item.userPhoneNumber);
    this.addCustomer();
  }

  getServerData(ev: PageEvent) {
    this.customerSearch.page = ev.pageIndex;
    this.customerSearch.size = ev.pageSize;
    this.getCustomers();
    return ev;
  }

  onBranchSelect(value: any) {
    this.customerSearch.channelId = value.channelId;
    this.getCustomers();
  }

  onGameLevelConfigsFormSumit() {
    this.dashboardService
      .updateGameLevelConfigs(
        this.loggedInUser.channelId,
        this.gameLevelsForm.value.gameLevels
      )
      .subscribe(
        (res: any) => {
          this.alertService.success("Configs updated successfully.");
          this.modalService.dismissAll();
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  onDeviceStatusClick(user) {
    this.matDialog.open(DeviceStatusDialogComponent, {
      data: { userId: user.customer.userId },
      width: "600px",
    });
  }
}
